function importDb (measurements, jsonFile) {
  return new Promise((resolve, reject) => {
    if (jsonFile.info !== undefined) {
      if (Object.keys(jsonFile.plots).length > 0) {
        // clear(resolve, measurements, importMeasurements, jsonFile)
        // clear(resolve, tmp, importMeasurements)
        importMeasurements(resolve, measurements, jsonFile.plots)
      } else {
        reject(new Error('File is empty'))
      }
    } else {
      reject(new Error('Invalid file'))
    }
  })
}

// clear databases and invoke the import function
/* function clear (resolve, db, callback, jsonFile) {
  db.clear().then(() => {
    if (jsonFile !== undefined) {
      callback(resolve, db, jsonFile.plots)
    }
  }).catch(function (err) {
    console.log(err)
  })
} */

// import database
function importMeasurements (resolve, db, plots) {
  let jsonLength = Object.keys(plots).length

  for (let key in plots) {
    db.setItem(key, plots[key]).then(() => {
      if (jsonLength === 1) {
        resolve() // execute after last iteration
      } else {
        jsonLength--
      }
    }).catch(function (err) {
      console.log(err)
    })
  }
}

export default importDb
